var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1655 4.23441C10.3155 4.38443 10.3998 4.58788 10.3998 4.80001C10.3998 5.01214 10.3155 5.21559 10.1655 5.36561L7.53113 8.00001L10.1655 10.6344C10.3113 10.7853 10.3919 10.9874 10.3901 11.1971C10.3882 11.4069 10.3041 11.6075 10.1558 11.7559C10.0075 11.9042 9.80681 11.9883 9.59705 11.9902C9.38729 11.992 9.18521 11.9113 9.03433 11.7656L5.83433 8.56561C5.68435 8.41559 5.6001 8.21214 5.6001 8.00001C5.6001 7.78788 5.68435 7.58443 5.83433 7.43441L9.03433 4.23441C9.18435 4.08444 9.3878 4.00018 9.59993 4.00018C9.81206 4.00018 10.0155 4.08444 10.1655 4.23441Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/ChevronLeft.46ed0b212f2a6eb005e004f0135156b2.svg";
export { ForwardRef as ReactComponent };